import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=01ffe7c2&scoped=true&"
import script from "./OrderRow.vue?vue&type=script&lang=ts&"
export * from "./OrderRow.vue?vue&type=script&lang=ts&"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=01ffe7c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffe7c2",
  null
  
)

export default component.exports